module.exports = "https://cdn.hellotech.com/client-assets/computers_desktop_ffeb83ec977a094aefc13c1eb4030841.webp";